module.exports = __webpack_public_path__ + "static/media/blank_video_thumbnail.c1710378.png";